import * as React from 'react';
import {useSelector} from 'react-redux';

import * as selectors from 'nutshell-core/assignables/assignables-selectors';

import {AssigneeSelect} from 'shells/assignee-select/assignee-select';

import type {NutshellState} from '../../../store';

import {useGetAssignable} from '../../core/graphql/hooks';
import {combineFetchedOptionsWithCurrentOptions} from '../../core/select/helpers';

export const PEEP_ASSIGNEE_SELECT_ID = 'account-assignee-select';

type Props = {
    assigneeId: string | null | undefined;
    onUpdatePeepAssignee: (assigneeId: string | null | undefined) => void;
    isDisabled?: boolean;
    placeholder?: string;
    withControlIcon?: boolean;
};

export function PeepAssigneeSelect(props: Props) {
    const {
        assigneeId,
        onUpdatePeepAssignee,
        isDisabled,
        placeholder = 'Select…',
        withControlIcon = true,
    } = props;
    const {assignable: assignee} = useGetAssignable(assigneeId);
    const activeAssignables = useSelector((state: NutshellState) => selectors.getAllEnabled(state));

    return (
        <AssigneeSelect
            inputId={PEEP_ASSIGNEE_SELECT_ID}
            placeholder={placeholder}
            onChange={onUpdatePeepAssignee}
            // @ts-expect-error
            options={combineFetchedOptionsWithCurrentOptions(activeAssignables, assignee)}
            value={assigneeId}
            withControlIcon={withControlIcon}
            hideDividerWhenEmpty={true}
            isDisabled={isDisabled}
        />
    );
}
